import { StyleSheet, Dimensions, Platform } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { getThemeColors } from '../../Themes/Modes'


const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderRadius: 6,
        overflow: 'hidden',
    },
    option: theme => ({
        flex: 1,
        height: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 70 : 50,
        padding: 8,
        backgroundColor: theme.colors.borderColorThree,
        justifyContent: 'center',
        alignItems: 'center',
        borderRightWidth: 1,
        borderRightColor: getThemeColors(theme.name).divider
    }),
    activeoption: {
        backgroundColor: Colors.vfRed,
    },
    firstLoader: {
        marginLeft: 0,
    },
    lastLoader: {
        marginRight: 0,
    },
    icon: theme => ({
        tintColor: theme.colors.inActiveColorThree,
    }),
    activeIcon: {
        tintColor: Colors.white,
    },
    disabledIcon: {
        tintColor: Colors.lightGrey,
    },
    disabled: {
        backgroundColor: 'rgba(235, 235, 235, 0.5)',
    },

})

export default styles
